import React, { ReactElement, SVGProps } from 'react'
import BaseIcon from "./BaseIcon";

export default function ArrowThinDownIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path
        d="M12 3.75v16.5M5.25 13.5 12 20.25l6.75-6.75"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  )
}
